import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../ui/Button.jsx";
import { TERMS_CONTENT, TERMS_VERSION } from "../legal/terms_v1.jsx";

export default function LegalTermsPage() {
  const navigate = useNavigate();
  return (
    <div
      style={{
        padding: 20,
        color: "#fff",
        minHeight: "100vh",
        background: "linear-gradient(180deg, rgba(17,17,20,1) 0%, rgba(8,8,10,1) 100%)",
      }}
    >
      <div
        style={{
          maxWidth: 960,
          margin: "0 auto",
          background: "rgba(255,255,255,0.04)",
          border: "1px solid rgba(255,255,255,0.12)",
          borderRadius: 18,
          padding: 20,
          boxShadow: "0 20px 60px rgba(0,0,0,0.35)",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 12,
            marginBottom: 12,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <Button
              variant="soft"
              className="px-3 py-1.5"
              onClick={() => navigate(-1)}
            >
              ← Back
            </Button>
            <div>
              <p style={{ margin: 0, fontSize: 12, opacity: 0.7, letterSpacing: 1 }}>Legal</p>
              <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800 }}>Terms &amp; Conditions</h1>
              <p style={{ margin: 0, fontSize: 12, opacity: 0.65 }}>Version {TERMS_VERSION}</p>
            </div>
          </div>
        </div>
        <div style={{ overflowY: "auto", maxHeight: "75vh", paddingRight: 4 }}>
          {TERMS_CONTENT}
        </div>
      </div>
    </div>
  );
}
